import { useState } from "react";
import privateAxios from "../utils/axiosPrivate";
import { getHasPermissionURL } from "../utils/constants/apiEndPoints";

const useHasPermissionApi = () => {
  const [isLoading, setIsLoading] = useState(false);

  const checkPermission = async (permissionType) => {
    setIsLoading(true);
    try {
      const response = await privateAxios.post(
        getHasPermissionURL(permissionType)
      );

      return response.data.data;
    } catch {
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { checkPermission, isLoading };
};

export default useHasPermissionApi;
